import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AbstractComponentFlow } from './AbstractComponentFlow';
import { ManifestComponentExtensionType } from '../ManifestStore';
import { EditorReactComponentFlow } from './EditorReactComponentFlow';
export class BlocksWidgetComponentFlow extends AbstractComponentFlow {
  constructor() {
    super(...arguments);
    _defineProperty(this, "type", ManifestComponentExtensionType.BLOCKS);
  }
  async loadManifest(props) {
    var _props$appDataCompone;
    // @ts-expect-error no componentModel in the AppDataComponent type
    const compType = (_props$appDataCompone = props.appDataComponent.data) == null || (_props$appDataCompone = _props$appDataCompone.componentModel) == null ? void 0 : _props$appDataCompone.componentType;
    await this.manifestStore.setManifest(compType, ManifestComponentExtensionType.BLOCKS, await this.manifestLoader.load(compType));
  }
  async loadPanels(props) {
    await new EditorReactComponentFlow(this.dm, this.editorPointerAPI, this.manifestUrlResolver, this.manifestStore, this.panelStore, this.wixCLIIntegrationAPI).loadPanels(props);
  }
}
//# sourceMappingURL=BlocksWidgetComponentFlow.js.map